import React from 'react'
import './InsLoader.scss'
import PropTypes from 'prop-types'


const defaultClasses = "account-check-picto lds-spinner";

const InsLoader = ({classes = defaultClasses}) => {
  return (
    <div className={classes}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  )
}

InsLoader.propTypes = {
  classes: PropTypes.string
}

export default InsLoader